export default function useGenderFilter() {
    function setupInstallmentPlans() {
        function generateCartItems() {
            const activeValues = new Set();
            const activeTexts = new Set();
          
            document.querySelectorAll(".filter-menu .filter-content .filter-body .filter-section").forEach((section) => {
                const titleElement = section.querySelector(".filter-section-title");
                if (titleElement && titleElement.textContent.trim() === "Recipient") {
                  section.querySelectorAll("label").forEach((label) => {
                    const checkbox = label.querySelector("input[type='checkbox']");
                    if (checkbox && checkbox.checked) {
                      const className = Array.from(checkbox.classList).find(c => c !== 'filter-checkbox');
                      const text = label.textContent.trim();
                      if (className) {
                        activeValues.add(className);
                        activeTexts.add(text);
                      }
                    }
                  });
                }
            });
          
            const cartItemsHTML = [];

            const firstText = Array.from(activeTexts)[0];
            let chang_text = 'Both';
            if(firstText == 'For Him'){
                chang_text = 'Men';
            }
            if(firstText == 'For Her'){
                chang_text = 'Women';
            }
          
            cartItemsHTML.push(`
              <div class="cart-item-gender custom_tab all-item-recept ${activeValues.size === 0 ? 'isactive' : ''}">
                <label for="cat-all-gender">
                  <input id="cat-all-gender" type="checkbox" name="category[]" value="all" ${activeValues.size === 0 ? 'checked' : ''}>
                  <span>Both</span>
                </label>
              </div>
            `);
          
            const filterSections = document.querySelectorAll(".filter-section");
            if (!filterSections.length) return;
          
            filterSections.forEach((section) => {
              const titleElement = section.querySelector(".filter-section-title");
              if (!titleElement) return;
          
              if (titleElement.textContent.trim() === "Recipient") {
          
                const labels = section.querySelectorAll(".filter-section-content label");
                if (!labels.length) return;
          
                labels.forEach((label) => {
                  const input = label.querySelector("input[type='checkbox']");
                  if (!input) return;
          
                  const termText = label.textContent.trim();
                  const className = Array.from(input.classList).find(c => c !== "filter-checkbox");
                  const isChecked = className && activeValues.has(className);
          
                  cartItemsHTML.push(`
                    <div class="cart-item-gender custom_tab ${className} ${isChecked ? 'isactive' : ''}">
                      <label for="cat-${className}">
                        <input id="cat-${className}" type="checkbox" name="category[]" value="${className}" ${isChecked ? 'checked' : ''}>
                        <span>${termText === 'For Her' ? 'Women' : termText === 'For Him' ? 'Men' : termText}</span>
                      </label>
                    </div>
                  `);
                });
              }
            });
          
            const container = document.createElement("div");
            container.classList.add("listing-recipients-custom");
            container.innerHTML = `
              <div class="box-cat-filter">
                <span class="box-cat__label">Gender:</span>
                <div class="box-cat__dropdown">
                  <div class="box-cat__dropdown-button">
                    <span>${chang_text}</span>
                    <span>
                      <img class="cs_dropdown" style="margin-top:2px;" src="data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='32'%20height='32'%20viewBox='0%200%2024%2024'%3e%3cpath%20fill='none'%20stroke='currentColor'%20stroke-linecap='round'%20stroke-linejoin='round'%20stroke-width='2'%20d='m8%2010l4%204l4-4'/%3e%3c/svg%3e" alt="">
                    </span>
                  </div>
                  <div class="custom_tabs">
                    ${cartItemsHTML.join("")}
                  </div>
                </div>
              </div>
            `;
          
            const parent = document.querySelector(".listing-page .listing-content");
            const target = document.querySelector(".listing-page .listing-collections-custom");
            const target2 = document.querySelector(".listing-page .listing-collections");
          
            if (target) {
              target.insertAdjacentElement("afterend", container);
            } else if (target2) {
              target2.insertAdjacentElement("afterend", container);
            } else if (parent) {
              parent.prepend(container);
            }
        }
    
        function setupEventHandlers() {
          function syncInitialState() {
            document.querySelectorAll(".filter-menu .filter-content .filter-body .filter-section").forEach((section) => {
              const titleElement = section.querySelector(".filter-section-title");
              if (titleElement && titleElement.textContent.trim() === "Recipient") {
                section
                  .querySelectorAll(".filter-section-content input[type='checkbox']")
                  .forEach((input) => {
                    const value = input.value;
                    const isChecked = input.checked;
                    const cartInput = document.querySelector(`.listing-recipients-custom .cart-item-gender input[value="${value}"]`);
                    if (cartInput) {
                      cartInput.checked = isChecked;
                    }
                  });
              }
            });
          }
          function toggleDropdown(){
            const customTabs = document.querySelector('.listing-recipients-custom .custom_tabs');
            if (customTabs){
              customTabs.classList.toggle("is-active");
            }
          }
          
    
          document.addEventListener("click", (event) => {
            const customTabs22 = document.querySelector('.listing-recipients-custom .custom_tabs');
            const listingRecipientsCustom = document.querySelector('.listing-recipients-custom');
    
            // Check if the click is outside the customTabs element and listing-recipients-custom
            if (customTabs22 && listingRecipientsCustom && !listingRecipientsCustom.contains(event.target)) {
                customTabs.classList.remove("is-active");
                
            }
            if (event.target.closest(".listing-recipients-custom .cart-item-gender.isactive")) {
                customTabs22.classList.remove("is-active");
                return;
            }
            if (event.target.closest(".listing-recipients-custom .cart-item-gender.all-item-recept")) {
                const allClearItems = document.querySelectorAll(".listing-recipients-custom .custom_tabs .cart-item-gender");
                allClearItems.forEach(item => {
                  item.classList.remove("isactive");
                });
                document.querySelectorAll(".filter-menu .filter-content .filter-body .filter-section").forEach((otherSection) => {
                    const otherTitleElement = otherSection.querySelector(".filter-section-title");
                    if (otherTitleElement && otherTitleElement.textContent.trim() === "Recipient") {
                      otherSection.querySelectorAll("input[type='checkbox']").forEach((checkbox) => {
                        checkbox.checked = false; 
                        checkbox.dispatchEvent(new Event("change"));
                        document.querySelector(".box-cat__dropdown-button span").innerHTML = 'Both';
                      });
                    }else{
                      return;
                    }
                });
            }
    
            if (event.target.closest(".listing-recipients-custom .cart-item-gender.all-item-recept.isactive")) {
                return;
            }
            if (event.target.matches(".listing-recipients-custom .cart-item-gender input[type='checkbox']")) {
              const input = event.target;
              const value = input.value;
              const allItems = document.querySelector(".listing-recipients-custom .cart-item-gender.all-item-recept");
    
              if (input.closest(".listing-recipients-custom .cart-item-gender").classList.contains("all-item-recept")) {
                console.log(input.closest(".listing-recipients-custom .cart-item-gender").classList.contains("all-item-recept"));
                document.querySelector(".box-cat__dropdown-button span").innerHTML = 'Both';
                toggleDropdown();
                const all_item = input.closest(".listing-recipients-custom .cart-item-gender");
                if (all_item) {
                    all_item.classList.add("isactive");
                }
                const allInactive = document.querySelectorAll(".listing-recipients-custom .cart-item-gender:not(.all-item-recept)").length ===
                  document.querySelectorAll(".listing-recipients-custom .cart-item-gender:not(.all-item-recept):not(.isactive)").length;
          
                if (allInactive) {
                  allItems.classList.add("isactive");
                  return;
                } else {
                  allItems.classList.remove("isactive");
                  document.querySelectorAll(".listing-recipients-custom .cart-item-gender").forEach((item) => {
                    if (!item.classList.contains("all-item-recept")) {
                      item.classList.remove("isactive");
                    }else{
                      item.classList.add("isactive");
                    }
                  });
          
                  document.querySelectorAll(".listing-recipients-custom .cart-item-gender input[type='checkbox']").forEach((checkbox) => {
                    checkbox.checked = false;
                  });
          
                  document
                    .querySelectorAll(".filter-menu .filter-content .filter-body .filter-section")
                    .forEach((section) => {
                      const titleElement = section.querySelector(".filter-section-title");
                      if (titleElement && titleElement.textContent.trim() === "Recipient") {
                        section.querySelectorAll("input[type='checkbox']").forEach((checkbox) => {
                          checkbox.checked = false;
                          checkbox.dispatchEvent(new Event("change"));
                        });
                      }
                    });
          
                  return;
                }
              }
              const clickedItem = input.closest(".listing-recipients-custom .cart-item-gender");
              if (clickedItem.classList.contains("isactive")) {
                return;
              } else {
                document.querySelectorAll(".listing-recipients-custom .cart-item-gender").forEach((item) => {
                  item.classList.remove("isactive");
                  item.querySelector("input[type='checkbox']").checked = false;
                });
                clickedItem.classList.add("isactive");
                input.checked = true;
                const label = clickedItem.querySelector("span").textContent;
                document.querySelector(".box-cat__dropdown-button span").innerHTML = label;
                toggleDropdown();
              }
              document
                .querySelectorAll(".filter-menu .filter-content .filter-body .filter-section")
                .forEach((section) => {
                  const titleElement = section.querySelector(".filter-section-title");
                  
                  if (titleElement && titleElement.textContent.trim() === "Recipient") {
                    section.querySelectorAll("input[type='checkbox']").forEach((checkbox) => {
                      checkbox.checked = false;
                      checkbox.dispatchEvent(new Event("change"));
                    });
          
                    const targetInput = Array.from(section.querySelectorAll("input[type='checkbox']")).find(input => 
                      input.classList.contains(value)
                    );
    
                    if (targetInput) {
                      targetInput.checked = input.checked;
                      targetInput.dispatchEvent(new Event("change"));
                    }
                  }
                });
            }
          
            if (event.target.matches(".filter-menu .filter-content .filter-body .filter-section input[type='checkbox']")) {
              const input = event.target;
              
              const section = input.closest(".filter-section");
              const titleElement = section.querySelector(".filter-section-title");
            
              if (titleElement && titleElement.textContent.trim() === "Recipient") {
                const value = input.classList.contains("filter-checkbox")
                  ? input.className.replace("filter-checkbox", "").trim()
                  : '';
               
            
                document.querySelectorAll(".filter-menu .filter-content .filter-body .filter-section").forEach((otherSection) => {
                  const otherTitleElement = otherSection.querySelector(".filter-section-title");
                  if (otherTitleElement && otherTitleElement.textContent.trim() === "Recipient") {
                    otherSection.querySelectorAll("input[type='checkbox']").forEach((checkbox) => {
                      if (checkbox !== input) {
                        checkbox.checked = false;
                        checkbox.dispatchEvent(new Event("change"));
                      }
                    });
                  }
                });
            
                document.querySelectorAll(".listing-recipients-custom .cart-item-gender input[type='checkbox']").forEach((checkbox) => {
                  checkbox.checked = false;
                  
                });
                document.querySelectorAll(".listing-recipients-custom .cart-item-gender").forEach((classItem) => {
                  classItem.classList.remove("isactive");
                });
                
                if (value) {
                  const targetCartInput = Array.from(document.querySelectorAll(".listing-recipients-custom .cart-item-gender")).find(cartItem => 
                    cartItem.classList.contains(value)
                  );
                  if (targetCartInput) {
                    const inputCheckbox = targetCartInput.querySelector("input[type='checkbox']");
                    inputCheckbox.checked = input.checked;
                    if (input.checked) {
                        targetCartInput.classList.add("isactive");
                    } else {
                        targetCartInput.classList.remove("isactive");
                    }
                  }
                }
              }
            }
            
          });
    
          // Bind click toggle action
          const dropdownBtn = document.querySelector(".box-cat__dropdown");
          const customTabs = document.querySelector('.listing-recipients-custom .custom_tabs');
          if (dropdownBtn && customTabs){
            dropdownBtn.addEventListener("click", (event) => {
              customTabs.classList.toggle('is-active');
            });
          }
          
          syncInitialState();
        }
    
        generateCartItems();
        setupEventHandlers();
    }
    if (process.client && (window.location.pathname.startsWith("/product-category/wedding-bands/") || window.location.pathname.startsWith("/ms-my/product-category/wedding-bands/") || window.location.pathname.startsWith("/product-category/rings/") || window.location.pathname.startsWith("/ms-my/product-category/rings/"))) {
        setupInstallmentPlans();
    }

}